import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-543a8cc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contact" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", null, " Email : "),
    /*#__PURE__*/_createTextVNode("jehee@contec.kr ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", null, " Phone : "),
    /*#__PURE__*/_createTextVNode("042-863-4532 ")
  ])
], -1))

import ModalTemplate from '@/components/common/modal/ModalTemplate.vue';
import useCommonStore from '@/store/storeCommon';


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotAccountModal',
  setup(__props) {

const { showModal } = useCommonStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalTemplate, {
    transitionName: "bounce",
    isModalOpen: _unref(showModal).isForgotAccount,
    errorTitle: "Forgot Account",
    isErrorMeteIcon: true
  }, {
    contentDescription: _withCtx(() => [
      _createTextVNode(" 계정 정보를 분실하신 경우"),
      _hoisted_1,
      _createTextVNode("크리에이티브 공모전 운영사무국으로"),
      _hoisted_2,
      _createTextVNode("연락 바랍니다. ")
    ]),
    contact: _withCtx(() => [
      _hoisted_3
    ]),
    _: 1
  }, 8, ["isModalOpen"]))
}
}

})